import React, { useEffect, useState } from 'react'
import AdminLayout from '../../UI/Layout/AdminLayout'
import Title from '../../UI/Text/Title'
import AdvanceDataTable from '../../UI/Table/AdvanceDataTable'
import Axios from 'axios'
import { userId } from '../../Utils/userAuth'
import { userloginDetails } from '../../Utils/AdminAuth'
import { HOST_URL } from '../../Dashboard/api/Api'
import { EMPLOYEE_WHATSAPP_ACCOUNT_LIST } from '../../UI/Table/ColumnConst'
import ReactDatePicker from "react-datepicker";


const EmployeeWhatsappOnboardingList = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const adminType = lStorage.user.isAdmin;

    const [allUserList, setAllUserList] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [ErrorResponse, setErrorResponse] = useState('');
    const [allDataList, setAllDataList] = useState([]);
    const [filter, setFilter] = useState({
        fromdate: '',
        todate: '',
        filterStatus: '',
        routeFilter: '',
        sendingLimits: ''
    });

    useEffect(() => {
        WhatsappOnboarding();
    }, [])

    const formatDate = (date) => {
        return date.toLocaleString('en-CA', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).replace(',', '');
    };

    const addOneDay = (date) => {
        let newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 1);
        return newDate;
    };

    const WhatsappOnboarding = async () => {
        try {
            let { data } = await Axios.post(`${HOST_URL}/admin_user_list.php?user_id=${userId}&method=retrieve_whatsapp_user&type=${adminType}&token=${userToken}`)
            if (data.success) {
                setAllUserList(data.data)
                setIsLoading(false)
                setAllDataList(data.data);
            }
            else {
                setIsLoading(false)
                setErrorResponse(data.message);
            }
        } catch (error) {
            console.log(error)
            setIsLoading(false)
        }
    }

    const fromdateHandler = (data) => {
        setFilter({ ...filter, fromdate: data });
    };

    const todateHandler = (data) => {
        setFilter({ ...filter, todate: data });
    };

    const handleStausChange = (e) => {
        setFilter({ ...filter, filterStatus: e.target.value });
    };

    const handleFilterChange = (e) => {
        setFilter({ ...filter, routeFilter: e.target.value });
    };

    const handleLimitChange = (e) => {
        setFilter({ ...filter, sendingLimits: e.target.value });
    };

    const FilterData = () => {
        let tempData = [...allDataList]

        if (filter.fromdate && filter.todate) {
            tempData = tempData.filter(x =>
                (formatDate(x.created) >= formatDate(filter.fromdate)) &&
                (formatDate(x.created) < formatDate(addOneDay(filter.todate)))
            );
        }
        if (filter.routeFilter) {
            tempData = tempData.filter(x => x.route_name == filter.routeFilter)
        }
        if (filter.sendingLimits) {
            tempData = tempData.filter(x => x.daily_sending_limit == filter.sendingLimits)
        }
        if (filter.filterStatus) {
            tempData = tempData.filter(x => x.status == filter.filterStatus)
        }

        setAllUserList(tempData)
    }
    return (
        <div>
            <AdminLayout>
                <Title> Whatsapp Onboarding List</Title>

                <div className="row">
                    <div className="col-12 col-lg-12 col-xxl-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <label><b>Date Filter</b></label>
                                        <div style={{ display: "flex", gap: "10px" }}>
                                            <ReactDatePicker
                                                className="form-control"
                                                dateFormat="dd/MM/yyyy"
                                                selected={filter.fromdate}
                                                onChange={fromdateHandler}
                                                placeholderText="From Date"
                                            />

                                            <ReactDatePicker
                                                className="form-control"
                                                dateFormat="dd/MM/yyyy"
                                                selected={filter.todate}
                                                onChange={todateHandler}
                                                placeholderText="Date To"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-6">
                                        <button
                                            type="button"
                                            onClick={FilterData}
                                            className="btn btn-info float-right mt-4"
                                        >
                                            Filter
                                        </button>
                                    </div>
                                </div>

                                <div className="row mt-2">
                                    {/* <div className="col-4">
                                        <label><b>Route</b></label>
                                        <select
                                            className="form-control"
                                            value={filter.routeFilter}
                                            onChange={handleFilterChange}
                                        >
                                            <option value="">Select Route</option>
                                            <option value="AuthkeyPinnacle">Pinnacle</option>
                                            <option value="AuthkeyKarix">Karix</option>
                                        </select>
                                    </div> */}

                                    <div className="col-6">
                                        <label><b>Sending Limits</b></label>
                                        <select
                                            className="form-control"
                                            value={filter.sendingLimits}
                                            onChange={handleLimitChange}
                                        >
                                            <option value="">Sending Limits</option>
                                            <option value="250">250</option>
                                            <option value="1000">1000</option>
                                            <option value="100000">100000</option>
                                            <option value="1000000">1000000</option>
                                            <option value="0">Greater than 1000000</option>
                                        </select>
                                    </div>

                                    <div className="col-6">
                                        <label><b>Status</b></label>
                                        <select
                                            className="form-control"
                                            value={filter.filterStatus}
                                            onChange={handleStausChange}
                                        >
                                            <option value="">Select Status</option>
                                            <option value="0">Pending</option>
                                            <option value="1">Approved</option>
                                        </select>
                                    </div>
                                </div>

                                {allUserList && (
                                    <div className="row mt-2">
                                        <div className="col-6"></div>
                                        <div className="col-6">
                                            <p className="float-right">
                                                <b>Total Count: </b>{allUserList.length}
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {ErrorResponse && (
                        <div className="alert alert-danger" role="alert">
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <div>{ErrorResponse}</div>
                        </div>
                    )}

                        <div className="">
                            <AdvanceDataTable
                                // tableName={'WhatsApp Onboarding List'}
                                // filter={true}
                                tableCell={EMPLOYEE_WHATSAPP_ACCOUNT_LIST}
                                tableData={allUserList}
                                isLoading={isLoading}
                                // isError={this.state.ErrorResponse}
                                pagination={allUserList ? true : false}
                                paginationRowsPerPageOptions={[10, 25, 50, 100]}

                            />
                        </div>
                    </div>
                </div>
            </AdminLayout>
        </div>
    )
}

export default EmployeeWhatsappOnboardingList
